import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("QuoteSliderWidget", {
  title: "Quote Slider",
  attributes: {
    dotsDescription: {
      title: "Dots description",
      description: "Aria label description (for screen readers)",
    },
    quote: {
      title: "Quote",
      description: "The list of all quotes in the slider.",
    },
  },
  properties: ["quotes", "dotsDescription"],
  initialContent: {
    dotsDescription: "Foliennummer",
  },
});
